export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6338.ba452208.jpg";